'use client'
import { type ReactNode } from 'react'
import { useIsWindowBelowBreakpoint } from '@/lib/utils/use-window-size'

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const IsSmall = ({
  children,
  maxSizeForScroll = 'sm',
}: {
  children: ReactNode
  maxSizeForScroll?: Breakpoint
}) => {
  const isSmall = useIsWindowBelowBreakpoint(maxSizeForScroll)
  if (isSmall) {
    return <>{children}</>
  }
  return null
}

export const IsLarge = ({
  children,
  maxSizeForScroll = 'sm',
}: {
  children?: ReactNode
  maxSizeForScroll?: Breakpoint
}) => {
  const isSmall = useIsWindowBelowBreakpoint(maxSizeForScroll)
  if (!isSmall) {
    return <>{children}</>
  }
  return null
}
